import axios from 'axios'
let axios_client = undefined

export const client = () => {
  if (axios_client === undefined) {
    axios_client = axios.create({
      baseURL: process.env.REACT_APP_SERVER_ADDRESS,
    })

    axios_client.interceptors.request.use(function (config) {
      let token = localStorage.getItem('provider_portal_access_token')
      if (token && token !== 'undefined') {
        config.headers['Authorization'] = 'Bearer ' + token
      }
      return config
    })
  }

  return axios_client
}
